<template>
  <el-dialog
      :visible.sync="visible"
      :show-close="true"
      custom-class="chart-dialog"
      width="100%"
      @close="handleClose"
  >
    <div class="chart-content">
      <!-- 自定义关闭按钮 -->
      <div class="close-btn">
        <el-button
            class="close-icon"
            type="text"
            icon="el-icon-close"
            @click="handleClose"
            aria-label="关闭"
        />
      </div>
      <!-- 聊天iframe -->
      <div class="chart-main">
        <iframe
            :src="chatUrl"
            frameborder="0"
            class="chat-frame"
        ></iframe>
      </div>

      <!-- 底部信息栏 -->
      <div class="chart-bottom">
        <div class="company-info">
          <div class="logo">
            <img :src="require('@/assets/images/logo-active.png')" alt="亚科Logo">
          </div>
          <div class="company-details">
            <h3 class="company-name norem">亚科股份</h3>
            <div class="contact-info norem">
              <div class="info-item norem">
                <span class="phone">13451648594</span>
              </div>
            </div>
          </div>
        </div>

        <div class="chart-btn norem">
          <el-button
              type="primary"
              @click="handleButtonClick"
          >
            留言
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'GoodChart',

  props: {
    type: {
      type: String,
      default: 'chat', // 可选值：chat, service, product
      validator: value => ['chat', 'service', 'product', 'customization'].includes(value)
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  watch: {
    item: {
      handler(newVal) {
        this.formData.belongs = newVal.belongs
        if(this.formData.belongs === 2){
          this.chatUrl = 'https://chatbot.weixin.qq.com/webapp/4dI4YGKLKglJxe9oEPnFyIrseJkvO6?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E6%98%9F%E7%A7%91%E5%85%83%E5%AE%A2%E6%9C%8D'
        }else{
          this.chatUrl = 'https://chatbot.weixin.qq.com/webapp/CJMBNZFGwytui4VHJTvYfMeMAE5Frb?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E4%BA%9A%E7%A7%91%E5%AE%A2%E6%9C%8D'
        }
      },
      immediate: true
    }

  },

  data() {
    return {
      formData: {
        belongs: 1
       },
      visible: false,
      chatUrl: 'https://chatbot.weixin.qq.com/webapp/CJMBNZFGwytui4VHJTvYfMeMAE5Frb?isFloat=false&robotName=%E4%BA%9A%E7%A7%91%E5%AE%98%E7%BD%91-%E4%BA%9A%E7%A7%91%E5%AE%A2%E6%9C%8D'
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    handleClose() {
      this.visible = false
    },

    handleButtonClick() {
      // 根据type调用不同的弹窗
      switch(this.type) {
        case 'service':
          this.$service(this.item)
          break
        case 'product':
          this.$product(this.item)
          break
        case 'customization':
          this.$croOrCdmo(this.item)
          break
        default:
          // 默认行为，可以是什么都不做
          console.log('默认聊天模式')
      }
    }
  },

  beforeDestroy() {
    // 确保组件销毁时清理资源
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="less">
.webapp-contain,
.webapp_window {
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}
</style>

<style lang="less" scoped>
@mainColor: #325177;

::v-deep .el-dialog {
  margin: 0 !important;
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  border-radius: 0 !important;
  background: #f7f8fa;
}

::v-deep .el-dialog__body {
  padding: 0;
  height: 100%;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  display: none;
}

.chart-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: #f7f8fa;
}

.chart-main {
  flex: 1;
  width: 100vw;
  height: calc(100vh - 72px);
  overflow: hidden;
  .chat-frame {
    width: 100vw;
    height: 100%;
    border: none;
    display: block;
    background: #fff;
  }
}

.chart-bottom {
  height: 72px;
  background: #fff;
  border-top: 1px solid #e5e6eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  .company-info {
    display: flex;
    align-items: center;
    .logo {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #F1F5F8;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      img {
        width: 28px;
        height: auto;
      }
    }
    .company-details {
      display: flex;
      flex-direction: column;
      .company-name {
        font-size: 15px;
        color: @mainColor;
        font-weight: 600;
        margin-bottom: 2px;
      }
      .contact-info {
        .info-item {
          .phone {
            color: #666;
            font-size: 13px;
          }
        }
      }
    }
  }

  .chart-btn {
    margin-left: 12px;
    :deep(.el-button) {
      width: 84px;
      height: 36px;
      background: @mainColor;
      border-color: @mainColor;
      border-radius: 18px;
      font-size: 15px;
      color: #fff;

      box-shadow: 0 2px 8px rgba(50,81,119,0.08);
      padding: 0;
      &:hover {
        background: lighten(@mainColor, 8%);
        border-color: lighten(@mainColor, 8%);
      }
    }
  }
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
    :deep(.el-button.close-icon) {
      width: 36px;
      height: 36px;
      border-radius: 18px;
      background: rgba(0, 0, 0, 0.04);
      color: #555;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
        &:hover {
          background: rgba(0, 0, 0, 0.08);
          color: #222;
        }
    }
}
</style> 